import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    isOut: 0, //退出不在重连websocket  0:没有退出  1：退出
    isLogin: 0 // 0：离线 1：暂停 2：接单
  },
  getters: {},
  mutations: {
    setisOut(state, newstate) {
      state.isOut = newstate;
    },
    setisLogin(state, newstate) {
      state.isLogin = newstate;
    }
  },
  actions: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js